module.exports = __webpack_public_path__ + "iPhone_6_7_8_icon.svg?ae32a169a2957e2e7895254238ff85c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPhone_6_7_8_icon.svg
// module id = 227
// module chunks = 0